import {
  useState,
  createContext,
  useContext,
  Dispatch,
  SetStateAction,
} from 'react';

type IFarolStatusContext = {
  farolStatus: boolean;
  setFarolStatus: Dispatch<SetStateAction<boolean>>;
};

const FarolStatusContext = createContext<IFarolStatusContext>(
  {} as IFarolStatusContext,
);

export const FarolStatusProvider = ({ children }) => {
  const [farolStatus, setFarolStatus] = useState<boolean>(false);

  return (
    <FarolStatusContext.Provider value={{ farolStatus, setFarolStatus }}>
      {children}
    </FarolStatusContext.Provider>
  );
};
export function useFarolStatusContext() {
  const context = useContext(FarolStatusContext);

  return context;
}
